import React from "react";

import './SpinnerLoader.scss';

const SpinnerLoader = () => {
    const r = 45;
    const cx = 50;
    const cy = 50;
    return (
        <div id="spinner-loading">
            <svg className="progress-ring">
                <circle className="progress-ring__bg" r={r} cx={cx} cy={cy}>
                </circle>
                <circle className="progress-ring__circle" r={r} cx={cx} cy={cy}>
                </circle>
            </svg>
        </div>
    )
}

export default SpinnerLoader;